export default["__VITE_ASSET__slGTL0$y__","__VITE_ASSET__DIQaVMwN__"];